import { errors } from "../constants";
import { createErrorResult, SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import {
  ITrackingBatchRideTrackingsDto,
  ITrackingInfoDto,
  ITrackingListFetchOptionsDto,
} from "../models";

export class TrackingApi {
  static async fetchTrackingInfos(
    rideId: number,
    options?: ITrackingListFetchOptionsDto,
    abortController?: AbortController,
  ): Promise<SimpleResult<ITrackingInfoDto[]> | undefined> {
    const companyId = getCompanyId();

    if (!rideId) {
      return createErrorResult<ITrackingInfoDto[]>(errors.ride.invalidRideId);
    }

    const requestUrl = `/api/v1/core/c/${companyId}/trackings/${rideId}/tracking-info`;
    const response = await Api.post<SimpleResult<ITrackingInfoDto[]>>(
      requestUrl,
      options,
      abortController,
    );

    return response?.data;
  }

  static async fetchTrackingInfosBatch({
    rideIds,
    options,
    abortController,
  }: {
    rideIds: number[];
    options?: ITrackingListFetchOptionsDto;
    abortController?: AbortController;
  }): Promise<SimpleResult<ITrackingBatchRideTrackingsDto[]> | undefined> {
    const companyId = getCompanyId();

    if (!rideIds?.length) {
      return createErrorResult<ITrackingBatchRideTrackingsDto[]>(
        errors.ride.invalidRideId,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/trackings/tracking-info-multiple`;
    const response = await Api.post<
      SimpleResult<ITrackingBatchRideTrackingsDto[]>
    >(
      requestUrl,
      {
        rideIds,
        debugMode: options?.debugMode,
        lastTrackingOnly: options?.lastTrackingOnly,
      },
      abortController,
    );

    return response?.data;
  }
}
